import { Stack, StackProps } from '@mui/material'

export const Row: React.FC<React.PropsWithChildren<StackProps>> = ({
  children,
  sx,
  ...props
}) => (
  <Stack flexDirection="row" sx={{ ...sx, display: 'flex' }} {...props}>
    {children}
  </Stack>
)
